import {Component, OnDestroy, OnInit} from '@angular/core';
import {Job} from '../model/job';
import {Subscription} from 'rxjs';
import {AppService} from '../app.service';

@Component({
    selector: 'app-job-market',
    templateUrl: './job-market.component.html',
    styleUrls: ['./job-market.component.css'],
    standalone: false
})
export class JobMarketComponent implements OnInit, OnDestroy {

  data: Job[];
  jobsData: Subscription;
  loading = true;
  show = false;
  onJobMarketClickSubscription: Subscription;

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.jobsData = this.appService.jobsData
      .subscribe((data) => {
        this.data = data;
        this.loading = false;
      });

    this.appService.fetchJobs();

    this.onJobMarketClickSubscription =
        this.appService.onJobMarketClickSubject.subscribe(
            () => {
              this.show = !this.show;
            }
        );
  }

  ngOnDestroy(): void {
    this.jobsData.unsubscribe();
    this.onJobMarketClickSubscription.unsubscribe();
  }

}
